var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bed000",
    d: "M5.44 9.764h8.078L11.22 6.22 8.8 9.534 7.06 7.546zm-.51 3.153q-.799 0-1.344-.545a1.83 1.83 0 0 1-.544-1.343V1.888q0-.799.544-1.343Q4.13 0 4.93 0h9.14q.799 0 1.344.545.544.543.544 1.343v9.14q0 .8-.544 1.344-.544.545-1.344.545zm0-1.375h9.14a.5.5 0 0 0 .353-.16.5.5 0 0 0 .16-.353V1.888a.5.5 0 0 0-.16-.353.5.5 0 0 0-.353-.16H4.93a.5.5 0 0 0-.353.16.5.5 0 0 0-.16.353v9.14a.5.5 0 0 0 .16.354.5.5 0 0 0 .353.16m-3.042 4.416q-.799 0-1.343-.544A1.83 1.83 0 0 1 0 14.07V3.555h1.375V14.07a.5.5 0 0 0 .16.352.5.5 0 0 0 .353.16h10.516v1.375zM4.93 1.375h9.14a.5.5 0 0 1 .353.16.5.5 0 0 1 .16.353v9.14a.5.5 0 0 1-.16.354.5.5 0 0 1-.353.16H4.93a.5.5 0 0 1-.353-.16.5.5 0 0 1-.16-.353V1.888a.5.5 0 0 1 .16-.353.5.5 0 0 1 .353-.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.d2620180efbd55a04141d8d992ac9cb4.svg";
export { ForwardRef as ReactComponent };